import React, { useContext, useEffect, useState } from "react";
import ManagerReportContext from "../../../Context/ManagerReportContext/ManagerReportContext";
import managerAPI from "../../../apis/manager/managerAPI";
import localStorageStore from "../../../utils/localStorageStore";
import ManagerReportFilter from "./ManagerReportFilter";
import AuthContext from "../../Auth/Middleware/AuthContext";

const ManagerReports = () => {
  const {
    filtersData,
    setTemplateConfig,
    setFiltersData,
    setReportsData,
    setTemplatesList,
    setOnlyFiltersField,
    onlyFiltersField,
    setFilterOptions,
    filtersOptions,
    templatesList,
    defaultFields,
    defaultFilters,
    setNextPage,
    nextPage,
    setFilterFields,
    setFields,
    fields,
    pageSize,
    setActiveTemplate,
    setOriginalFiltersData,
    originalFiltersData,
    activeTemplate,
    setAllData,
  } = useContext(ManagerReportContext);
  const [pageNo, setPageNo] = useState(1);
  const [reportsIsLoading, setReportsIsLoading] = useState(true);
  const [localOnlyFilter, setLocalOnlyFilter] = useState({});
  const [localFields, setLocalFields] = useState([]);
  const [localFiltersData, setLocalFiltersData] = useState({});
  const [templateChanged, setTemplateChanged] = useState(false);
  const [filterOptionsLoading, setFilterOptionLoading] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false)
  const authContext = useContext(AuthContext);
  const [isAuditDoneDateSelected, setIsAuditDoneDateSelected] = useState({
    auditDoneMilestoneDate: false,
    dateOfCoding: false,
  });
  const [tempName, setTempName] = useState("");

  const onChange = (value, key) => {
    let fieldsData = JSON.parse(JSON.stringify(localFields));
    let item = JSON.parse(JSON.stringify(localFiltersData[key]));
    let changedData = JSON.parse(JSON.stringify(localFiltersData));
    let filterFields = JSON.parse(JSON.stringify(localOnlyFilter));
    if (value === "report") {
      if (item.reportChecked) {
        const index = fieldsData.indexOf(item.key);
        if (index > -1) {
          fieldsData.splice(index, 1);
        }
      } else {
        fieldsData.push(item.key);
      }
      changedData[key] = {
        ...item,
        reportChecked: !item.reportChecked,
      };
    } else {
      changedData[key] = {
        ...item,
        filterChecked: !item.filterChecked,
      };
      if (changedData[key].filterChecked) {
        filterFields[key] = changedData[key];
      } else {
        delete filterFields[key];
      }
    }
    setLocalOnlyFilter(filterFields);
    setLocalFields(fieldsData);
    setLocalFiltersData({ ...changedData });
  };

  const selectAllFilter = (allSelected) => {
    let filterFields = JSON.parse(JSON.stringify(localOnlyFilter));
    let changedData = JSON.parse(JSON.stringify(localFiltersData));

    if (allSelected) {
      Object.keys(changedData).forEach((key) => {
        changedData[key].filterChecked = false;
        delete filterFields[key];
      });
    } else {
      Object.keys(changedData).forEach((key) => {
        changedData[key].filterChecked = true;
        filterFields[key] = changedData[key];
      });
    }
    setLocalOnlyFilter(filterFields);
    setLocalFiltersData({ ...changedData });
  };

  const selectAllReport = (allSelected) => {
    let fieldsData = JSON.parse(JSON.stringify(localFields));
    let changedData = JSON.parse(JSON.stringify(localFiltersData));

    if (allSelected) {
      fieldsData = [];
      Object.keys(changedData).forEach(
        (key) => (changedData[key].reportChecked = false),
      );
    } else {
      Object.keys(changedData).forEach((key) => fieldsData.push(key));
      Object.keys(changedData).forEach(
        (key) => (changedData[key].reportChecked = true),
      );
    }
    setLocalFields(fieldsData);
    setLocalFiltersData({ ...changedData });
  };

  const onFilterSave = () => {
    setPageNo(1);
    setOnlyFiltersField(localOnlyFilter);
    setFiltersData(localFiltersData);
    setFields(localFields);
    fetchReports(localFields, false, { local: true });
  };

  useEffect(() => {
    restoreData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersData]);

  const getFilterPayload = (tempFilterField) => {
    let filterPayload = {};
    for (let a in tempFilterField) {
      if (
        ((a.endsWith("_total") || a.endsWith("_correct")) &&
          tempFilterField[a].value === 0) ||
        tempFilterField[a].value
      ) {
        if (tempFilterField[a].filterType === "select") {
          if (tempFilterField[a].multiselect) {
            if (tempFilterField[a].value.length > 0) {
              filterPayload[a] = tempFilterField[a].value.map(
                (item) => item.value,
              );
            }
          } else {
            if (Object.keys(tempFilterField[a].value).length > 0) {
              filterPayload[a] = tempFilterField[a].value.value;
            }
          }
        } else {  
          filterPayload[a] = tempFilterField[a].value;
        }
      }
    }

    return filterPayload;
  }

  const fetchReports = async (
    fields,
    exportFile = false,
    isLocal,
    forcePage = false,
  ) => {
    if (!exportFile) setReportsIsLoading(true);
    else setExportInProgress(true);

    let tempFilterField = isLocal ? localOnlyFilter : onlyFiltersField;

    const filterPayload = getFilterPayload(tempFilterField);
    
    if(authContext.globalClientId){
      const client = authContext.globalClientId?.value;
      if(+client) {
        filterPayload.client_name = [+client];
      }
    }
    
    if(authContext.globalLocationId){
      const locationProcess = authContext.globalLocationId?.value?.split('_');
      if(Array.isArray(locationProcess) && locationProcess[0] === 'location') {
        filterPayload.loc_name = [+locationProcess[1]];
      }
    }

    let sequence = [];
    if(exportFile) {
      const totalColumns = window.getReportTable()?.colReorder?.order();
      sequence = totalColumns ? totalColumns.map((d, idx) => {
        return window.getReportTable()?.column(idx)?.header()?.dataset?.headerKey ?? null;
      }).filter((key) => key !== null ) : [];
    }
    
    try {
      const userRole = localStorage.getItem("Role");
      if ((isAuditDoneDateSelected.auditDoneMilestoneDate || isAuditDoneDateSelected.dateOfCoding) && exportFile) {
        try {
         const result = await managerAPI.exportRequestSave({
            userRole,
            export: exportFile,
            fields: sequence.length > 0 ? sequence : fields,
            filters: filterPayload,
            templateName: tempName ? tempName : localStorage.getItem('templateName') ? localStorage.getItem('templateName') : '',
         });
          if (result) {
            setExportInProgress(false);
            window.toastr.info("Your data will be processed overnight. Please check again tomorrow.");
          }
        } catch (e) {
          setExportInProgress(false);
          window.toastr.error(e.message);
        }
      } else {
        let res = await managerAPI.getReports(
          {
            export: exportFile,
            fields: sequence.length > 0 ? sequence : fields,
            filters: filterPayload,
          },
          {
            page: forcePage ? forcePage : pageNo,
            size: pageSize,
          },
          exportFile,
          userRole,
        );
        if (exportFile) {
          window.location.assign(res.result.url);
          setExportInProgress(false);
        } else {
          setReportsData(res.result);
          setNextPage(res.next_page);
          setReportsIsLoading(false);
          setAllData(res);
        }
      }
    } catch (e) {
      if (!exportFile) setReportsIsLoading(false);
      else setExportInProgress(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  useEffect(() => {
    if(authContext.globalLocationId){
      getReportData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authContext.globalLocationId, pageNo, pageSize, templateChanged]);

  const getReportData = async () => {
    const authFilter = {
      client_name: 0,
      loc_name: 0
    };

    if(authContext.globalClientId?.value){
      const clientValue = authContext.globalClientId.value;
      authFilter.client_name = isNaN(clientValue) ? clientValue : Number(clientValue);
    }
    
    if(authContext.globalLocationId?.value){
      const locationParts = authContext.globalLocationId.value.split('_');
      if (Array.isArray(locationParts) && locationParts[1]) {
        authFilter.loc_name = Number(locationParts[1]) || 0;
      }
    }
    
    let res = await managerAPI.getColumns({ ClientId: authFilter?.client_name , LocationId: authFilter?.loc_name});
    // let res = await managerAPI.getColumns({ ClientId: authContext.globalClientId?.value, LocationId: authContext.globalLocationId?.value });
    setOriginalFiltersData(res);
    setFiltersData(res);
    let resCopy = {};
    let onlyFilters = {};
    if (activeTemplate !== "") {
      fetchTemplateConfig(activeTemplate, res);
    } else {
      if (res && Object.keys(res).length > 0) {
        resCopy = JSON.parse(JSON.stringify(res));

        for (let a in resCopy) {
          if (defaultFilters.includes(a)) {
            resCopy[a] = {
              ...resCopy[a],
              filterChecked: true,
            };
            onlyFilters[a] = {
              ...resCopy[a],
              filterChecked: true,
            };
          }
          if (defaultFields.includes(a)) {
            resCopy[a] = {
              ...resCopy[a],
              reportChecked: true,
            };
          }
        }
      }
      setFiltersData(resCopy);
      setOnlyFiltersField(onlyFilters);
      setFields(defaultFields);
      fetchReports(defaultFields);
    }
  };

  const fetchFiltersOptions = async () => {
    try {
      setFilterOptionLoading(true);
      let payload = [];
      for (let a in onlyFiltersField) {
        payload.push(a);
      }
      let res = await managerAPI.getFilterOptions({
        filters: payload,
      });
      if (res && res.success && res.data) {
        setFilterOptions(res.data);
      }
      setFilterOptionLoading(false);
    } catch (e) {
      setFilterOptionLoading(false);
    }
  };

  useEffect(() => {
    fetchFiltersOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onlyFiltersField]);

  const onFilterChange = (val, key, name, i) => {
    let dataFilter = onlyFiltersField;
    dataFilter[key].value = val;
    setFilterFields({ ...dataFilter });
  };

  const onFilterClick = () => {
    setPageNo(1);
    fetchReports(fields, false, false, 1);
  };

  const handleNextPrev = (val) => {
    if (!reportsIsLoading) {
      if (pageNo > 0) {
        if (val === "next") {
          setPageNo(pageNo + 1);
        } else {
          if (pageNo > 1) {
            setPageNo(pageNo - 1);
          }
        }
      }
    }
  };

  const fetchTemplates = async () => {
    let res = await managerAPI.getAllTemplates();
    setTemplatesList(res);
  };

  const restoreData = () => {
    setLocalOnlyFilter(onlyFiltersField);
    setLocalFields(fields);
    setLocalFiltersData(filtersData);
    setIsAuditDoneDateSelected({
      auditDoneMilestoneDate: false,
      dateOfCoding: false,
    });
  };

  const fetchTemplateConfig = async (id, filterData = null, forcePage = null, name) => {
    try {
      setTempName(name);
      setReportsIsLoading(true);
      setActiveTemplate(id);
      if(forcePage) {
        setPageNo(1);
      }
      localStorageStore.setDefaultTemplate(id);
      if (name) {
        localStorage.setItem("templateName", name);
      }
      let res = await managerAPI.getTemplateConfig(id);
      let filterdDataCopy = filterData == null ? JSON.parse(JSON.stringify(originalFiltersData)) : JSON.parse(JSON.stringify(filterData));
      let onlyFilters = {};
      setTemplateConfig(res);
      for (let b in filterdDataCopy) {
        filterdDataCopy[b] = {
          ...filterdDataCopy[b],
          reportChecked: false,
          filterChecked: false,
        };
      }
      if (res && res.length > 0) {
        res.forEach((item) => {
          filterdDataCopy[item.field_name] = {
            ...filterdDataCopy[item.field_name],
            reportChecked: item.report,
            filterChecked: item.filter,
            sortOrder: item.sort_order,
            id: item.id,
          };
          if (item.filter) {
            onlyFilters[item.field_name] = {
              ...filterdDataCopy[item.field_name],
              reportChecked: item.report,
              filterChecked: item.filter,
              id: item.id,
            };
          }
        });
      }

      let payload = [];
      setOnlyFiltersField(onlyFilters);
      setFiltersData(filterdDataCopy);
      for (let a in filterdDataCopy) {
        let item = filterdDataCopy[a];
        if (item.reportChecked) {
          if(item.sortOrder !== null){
            payload[item?.sortOrder - 1] = item.key;
          } else {
            payload.push(item.key);
          }
        }
      }
      setFields(payload);
      fetchReports(payload);
      setReportsIsLoading(false);
    } catch (e) {
      setReportsIsLoading(false);
    }
  };

  return (
    <>
      <ManagerReportFilter
        templatesList={templatesList}
        onTemplateSelect={fetchTemplateConfig}
        handleNextPrev={handleNextPrev}
        onFilterClick={onFilterClick}
        filterFields={onlyFiltersField}
        onFilterChange={onFilterChange}
        onFilterSave={onFilterSave}
        onChange={onChange}
        onExport={fetchReports}
        filtersData={filtersData}
        nextPage={{
          nextPage: nextPage,
          currentPage: pageNo,
          setPageNo: setPageNo,
        }}
        reportsIsLoading={reportsIsLoading}
        filtersOptions={filtersOptions}
        localFiltersData={localFiltersData}
        onDiscard={restoreData}
        filterOptionsLoading={filterOptionsLoading}
        selectAllFilter={selectAllFilter}
        selectAllReport={selectAllReport}
        exportInProgress={exportInProgress}
        setTemplateChanged={setTemplateChanged}
        setIsAuditDoneDateSelected={setIsAuditDoneDateSelected}
        setTempName={setTempName}
      />
    </>
  );
};
export default ManagerReports;
